import { persistUrlParams } from "@faire/help-center-utils/lib/persistUrlParams";
import { LoggedOutContactUsContextProvider } from "@faire/help-center/views/logged-out-contact-us/hooks/LoggedOutContactUsContextStore";
import { LoggedOutEmailContextProvider } from "@faire/help-center/views/logged-out-contact-us/hooks/LoggedOutEmailContextStore";
import { LoggedOutContactUsModal } from "@faire/help-center/views/logged-out-contact-us/surfaces/LoggedOutContactUsModal";
import { route as supportSelfServeRoute } from "@faire/web-api/routes/support/self-serve";
import React from "react";
import { Redirect } from "react-router-dom";
import { LoginModal } from "../Login/LoginModal";
import { useContactStrategy } from "./hooks/useContactStrategy";
export var ContactStrategy = function ContactStrategy() {
  var _useContactStrategy = useContactStrategy(),
    isUserLoggedIn = _useContactStrategy.isUserLoggedIn,
    isLoggedOutExperience = _useContactStrategy.isLoggedOutExperience,
    shouldShowContactModal = _useContactStrategy.shouldShowContactModal;
  if (!shouldShowContactModal()) {
    return null;
  }
  if (!isLoggedOutExperience()) {
    if (!isUserLoggedIn()) {
      return /*#__PURE__*/React.createElement(LoginModal, null);
    }
    return /*#__PURE__*/React.createElement(Redirect, {
      to: persistUrlParams(supportSelfServeRoute, ["contact"])
    });
  }
  return /*#__PURE__*/React.createElement(LoggedOutContactUsContextProvider, null, /*#__PURE__*/React.createElement(LoggedOutEmailContextProvider, null, /*#__PURE__*/React.createElement(LoggedOutContactUsModal, null)));
};